export const clearDocumentTemplateDraft = (value = {}) => ({
  id: value?.id ?? null,
  name: "",
  title: "",
  content: "",
  active: true,
  sortOrder: 0,
  templateMode: "html",
  sourcePdfRef: null,
  sourceFileName: null,
  overlayConfig: [],
  _sourceRevision: Date.now(),
});

export default clearDocumentTemplateDraft;
